var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 6.79167H16.5L16.4988 10.9167C16.4988 11.3643 16.7641 11.7694 17.1742 11.948C17.5844 12.1267 18.062 12.0454 18.3897 11.7415L23.6397 6.86639C23.8781 6.64167 24 6.34167 24 5.99947C24 5.65728 23.88 5.39806 23.6403 5.1754L18.3903 0.300312C18.0629 -0.00363041 17.585 -0.0850537 17.1748 0.0936838C16.7647 0.272421 16.4993 0.677756 16.4993 1.12495L16.5 5.29165H0.75C0.335438 5.29165 0 5.62915 0 5.99947C0 6.36979 0.335438 6.79167 0.75 6.79167ZM18 2.02628L22.3242 6.04166L18 10.0589V2.02628ZM23.25 17.2497H7.5L7.50124 13.1668C7.50124 12.7193 7.23592 12.3141 6.82577 12.1355C6.41561 11.9569 5.93906 12.0371 5.61094 12.3418L0.360937 17.2169C0.119953 17.4419 0 17.7419 0 17.9997C0 18.2575 0.119953 18.602 0.359719 18.8247L5.60972 23.6998C5.93709 24.0037 6.41503 24.085 6.82519 23.9063C7.2375 23.7701 7.5 23.3623 7.5 22.917V18.7497H23.25C23.6646 18.7497 24 18.4142 24 18.0419C24 17.6695 23.6625 17.2497 23.25 17.2497ZM6 22.0591L1.67578 18.0419L6 14.0246V22.0591Z",
    fill: "#E5E5EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferOutline);
export default __webpack_public_path__ + "static/media/transfer-outline.290cba45c63702ad24ba5bfe80a81daf.svg";
export { ForwardRef as ReactComponent };